import { IStation } from '@helpers/types';
import React, { useCallback, useEffect, useState } from 'react';

export interface IStationSwitcherContext {
  station: IStation | null;
  destStation: IStation | null;
  temporal: IStation | null;
  desTemporal: IStation | null;
  onChangeStation: (station: IStation) => void;
  onChangeDestStation: (station: IStation) => void;
  visible: boolean;
  onConfirmStation: () => void;
  onShowStationSelector: () => void;
  onHideStationSelector: () => void;
  onChangeCountry: (e: any) => void;
  currentCountry: string;
}

export const StationSwitcherContext =
  React.createContext<IStationSwitcherContext>({
    station: null,
    destStation: null,
    temporal: null,
    desTemporal: null,
    visible: false,
    currentCountry: '',
    onChangeStation: (_station: IStation) => {},
    onChangeDestStation: (_station: IStation) => {},
    onConfirmStation: () => {},
    onShowStationSelector: () => {},
    onHideStationSelector: () => {},
    onChangeCountry: (_e: any) => {},
  });

export const StationContextProvider = (props: any) => {
  const defaultContext = useStationContextProvider();
  return (
    <StationSwitcherContext.Provider value={defaultContext}>
      {props.children}
    </StationSwitcherContext.Provider>
  );
};

export const useStationContextProvider = (): IStationSwitcherContext => {
  const [visible, setVisible] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [station, setStation] = useState<IStation | null>(null);
  const [destStation, setDestStation] = useState<IStation | null>(null);
  const [temporal, setStationTemporal] = useState<IStation | null>(null);
  const [desTemporal, setDestStationTemporal] = useState<IStation | null>(null);
  const [currentCountry, setCurrentCountry] = useState<string>('');

  const onChangeStation = useCallback((station: IStation) => {
    setStationTemporal(station);
  }, []);

  const onChangeDestStation = useCallback((station: IStation) => {
    setDestStationTemporal(station);
  }, []);

  const onConfirmStation = useCallback(() => {
    setStation(temporal);
    setDestStation(desTemporal);
    localStorage.setItem('station', JSON.stringify(temporal));
    localStorage.setItem('dest_station', JSON.stringify(desTemporal));
    setVisible(false);
    window.location.reload();
  }, [temporal, desTemporal]);

  const onShowStationSelector = useCallback(() => {
    setVisible(true);
  }, []);

  const onHideStationSelector = useCallback(() => {
    setVisible(false);
  }, []);

  const onChangeCountry = useCallback((e: any) => {
    setStationTemporal(null);
    setDestStationTemporal(null);
    setCurrentCountry(e.target.value as string);
  }, []);

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      const s: string | null = localStorage.getItem('station');
      if (s) {
        setStation(JSON.parse(s));
        setStationTemporal(JSON.parse(s));
      } else {
        onShowStationSelector();
      }
      const d: string | null = localStorage.getItem('dest_station');
      if (d) {
        setDestStation(JSON.parse(d));
        setDestStationTemporal(JSON.parse(d));
      } else {
        onShowStationSelector();
      }
    }
  }, [loaded]);

  return {
    temporal,
    desTemporal,
    visible,
    station,
    destStation,
    currentCountry,
    onChangeStation,
    onChangeDestStation,
    onConfirmStation,
    onShowStationSelector,
    onHideStationSelector,
    onChangeCountry,
  };
};
